import { useQuery, gql } from '@apollo/client';
import { useEffect, useState } from 'react';

const SERVER_TIME_QUERY = gql`
  query GetServerTime {
    serverTime
  }
`;

/**
 * Hook that provides server time (respects test clock)
 * Falls back to client time if server time is not available
 */
export function useServerTime() {
  const [serverTime, setServerTime] = useState<Date>(new Date());
  const [isUsingServerTime, setIsUsingServerTime] = useState(false);
  
  const { data, loading, error } = useQuery(SERVER_TIME_QUERY, {
    pollInterval: 60000, // Poll every minute to keep time in sync
    fetchPolicy: 'network-only'
  });
  
  useEffect(() => {
    if (data?.serverTime) {
      const newServerTime = new Date(data.serverTime);
      setServerTime(newServerTime);
      setIsUsingServerTime(true);
      // Log the server time with an obvious emoji
      console.log('⏰ [useServerTime] Retrieved server time:', newServerTime.toISOString());
    } else {
      // Fallback to client time
      const now = new Date();
      setServerTime(now);
      setIsUsingServerTime(false);
      // Optionally, you could log fallback as well, but not required by prompt
    }
  }, [data]);
  
  // Update time every second
  useEffect(() => {
    const interval = setInterval(() => {
      setServerTime(prev => new Date(prev.getTime() + 1000));
    }, 1000);
    
    return () => clearInterval(interval);
  }, []);
  
  return {
    serverTime,
    isUsingServerTime,
    loading,
    error
  };
} 